<template>
  <Card tag="form" class="project-flatfinder-mutate-basis" @submit.prevent="$emit('submit')">
    <template #default>
      <div class="project-flatfinder-mutate-basis__input">
        <FieldRenderer v-for="item in fields.default" :item="item" :value="value" />

        <CustomFields
          v-model="value.customFields"
          :schema="customFieldSchemas"
          :data="data"
          :validator="validator"
          validator-prefix="customFields"
          :placement="['flatfinder:basis']"
        >
          <template v-for="item in fields.slots" v-slot:[item.slotKey]>
            <FieldRenderer :item="item" :value="value" />
          </template>
        </CustomFields>
      </div>
    </template>
  </Card>
</template>

<script>
import { i18n } from '@/i18n'

import Card from '@/components/Card'

import CustomFields from '@kvass/custom-fields'
import FieldRenderer from '@/components/Flatfinder/StepsFields/FieldRenderer'

const meta = {
  order: 1,
  id: 'basis',
  label: i18n.tc('basis'),
  icon: ['fal', 'file-alt'],
}

export { meta }
export default {
  props: {
    value: Object,
    project: String,
    data: Object,
    labels: Object,
    validator: Object,
    customFieldSchemas: { type: Array, default: () => [] },
    fields: { type: Object, default: () => ({}) },
  },

  components: {
    Card,
    CustomFields,
    FieldRenderer,
  },
}
</script>

<style lang="scss">
.project-flatfinder-mutate-basis {
  max-width: 900px;

  --columns: 1;

  [data-field='frames.0.image'] {
    .kvass-media-droparea {
      min-height: 500px;
    }
  }

  .custom-fields {
    grid-column-end: span var(--columns);
  }

  &__input {
    display: grid;
    grid-template-columns: repeat(var(--columns), 1fr);
    grid-gap: $form-gap;
  }
}
</style>
